import { File } from "./File/File";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Files.module.css";
import { Trans } from "@coworker/locales";

export type FileItem = {
  name: string;
  size: string;
  onDownload: () => void;
};

type FilesProps = {
  items: FileItem[];
};

export function Files({ items }: FilesProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={styles["container"]}>
      <FixaText textStyle="Heading.S">
        <Trans>filesStringCapitalized</Trans>
      </FixaText>
      <div className={styles["filesWrapper"]}>
        {items.map(({ name, size, onDownload }, i) => (
          <File key={i} name={name} size={size} onDownload={onDownload} />
        ))}
      </div>
    </div>
  );
}
